<template>
    <div class="row gx-3">
        <pc-input-group class="col-12">
            <pc-radio-group
                v-bind="binder"
                v-bind:label="label"
                v-bind:options="options"
                v-bind:name="dataFieldId"
                value-prop="ListItemDefinitionId"
                text-prop="Label"
                data-test-role="radiobuttonlist-element"
                v-on="listeners"
                v-on:help-clicked="emitHelpClicked">
                <template v-slot:afterLabel>
                    <slot name="help" />
                </template>
            </pc-radio-group>
        </pc-input-group>
        <validation-render-helper v-bind:validation-error="validationError" />
    </div>
</template>

<script>
    import base, { getOptionsFromAuxiliaryModelMixin, validationRenderHelper } from "./_elementBase";
    export default {
        components: { validationRenderHelper },
        extends: base,
        mixins: [getOptionsFromAuxiliaryModelMixin],
        computed: {
            options() {
                return this.getOptionsFromAuxiliaryModel();
            }
        }
    };
</script>
